import React from 'react';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { makeStyles } from 'tss-react/mui';
import { Grid, Link, Typography, units } from '@hbf/dsl';
import { LockShieldLight } from '@ha/icons';

const useStyles = makeStyles()(theme => ({
  container: {
    background: theme.palette.orange.light,
    borderRadius: units.rem(0.25),
    padding: units.yx(1.547, 1.544),
  },
  icon: {
    marginRight: units.rem(1.294),
  },
  link: {
    color: theme.palette.primary.dark,
    boxShadow: 'inset 0px -1px 0px rgba(136, 34, 85, 0.3)',
    paddingBottom: units.rem(0.125),
  },
  text: {
    marginTop: units.rem(0.5),
    marginBottom: units.rem(0.188),
  },
  title: {
    color: theme.palette.grey[600],
  },
}));

const Safeguard: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { classes } = useStyles();
  const { sm } = useMediaQuery();

  return (
    <Grid
      container
      direction="row"
      className={classes.container}
      data-test-locator="48-hours sageguard card"
    >
      <Grid item xs={2}>
        <LockShieldLight
          fontSize={sm ? 'large' : 'small'}
          className={classes.icon}
        />
      </Grid>
      <Grid item xs={10}>
        <Grid container>
          <Grid item>
            <Typography.H4 className={classes.title}>
              {T('listings.details.cancellation_policy.48h_safeguard.name')}
            </Typography.H4>
          </Grid>
          <Grid item className={classes.text}>
            <Typography.Paragraph>
              {T('listings.details.cancellation_policy.48h_safeguard')}
            </Typography.Paragraph>
          </Grid>
          <Grid item>
            <Link
              className={classes.link}
              target="_blank"
              to={urlResolver.getCancellationPolicyHelpUrl()}
            >
              {sm ? T('Read more.') : T('cta_learn_more')}
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { Safeguard };
